<template>
    <div v-if="!cookiePolicy" class="main-notice">
        <div class="page__container">
            <div class="cookie-notice">
                <div class="cookie-notice__info">
                    <p>
                        Наш портал использует файлы cookie и аналогичные технологии для показа более релевантного контента и рекламы для повышения вашего удобства.
                        Чтобы узнать больше о файлах cookie и их использовании, ознакомьтесь с нашей политикой использования <a href="/cookie-policy">файлов cookie</a>.
                        Продолжая использовать наш портал или нажав «Принимаю», Вы соглашаетесь с Политикой использования файлов cookie.
                    </p>
                </div>
                <div class="cookie-notice__actions">
                    <button class="r-button button" type="button" @click="cookieAgree">Принимаю</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "cookie",
        data() {
            return {
                cookiePolicy: true
            }
        },
        props: {
            hideMessage: {
                default: false,
            }
        },
        mounted() {
            if (this.hideMessage) {
                this.$cookie.setCookie('cookie-policy', true, 31);
            }

            this.cookiePolicy = !!this.$cookie.getCookie('cookie-policy');
        },
        methods: {
            cookieAgree() {
                this.$cookie.setCookie('cookie-policy', true, 31);

                this.cookiePolicy = true;
            }
        }
    }
</script>
